import apiClient from './apiClient';

// ── Filter Parameters ──────────────────────────────────────────────────────
export interface QueryParams {
  customer_start?: string;   // P_START_01: 客戶代號起
  customer_end?: string;     // P_LAST_01:  客戶代號迄
  date_start?: string;       // P_START_02: 交運日期起 (YYYY-MM-DD)
  date_end?: string;         // P_LAST_02:  交運日期迄 (YYYY-MM-DD)
  product_start?: string;    // P_START_03: 產品代號起
  product_end?: string;      // P_LAST_03:  產品代號迄
  delivery_no_start?: string; // P_START_04: 交運單號起
  delivery_no_end?: string;   // P_LAST_04:  交運單號迄
  sales_start?: string;      // P_START_05: 業務代號起
  sales_end?: string;        // P_LAST_05:  業務代號迄
  sort_by?: number;          // 排序方式 (1=客戶別, 2=交運日別, 3=產品別)
  // Print type flags (CHECK1~CHECK5) — BR-V06: at least one required
  print_type_1?: boolean;    // 單據別
  print_type_2?: boolean;    // 客戶別
  print_type_3?: boolean;    // 日期別
  print_type_4?: boolean;    // 產品別
  print_type_5?: boolean;    // 業務員別
}

// ── Response Types ─────────────────────────────────────────────────────────
export interface ReportItem {
  fc120_no: string;       // 交運單號
  fc120_seq: number;      // 明細項次
  fc120_cust: string;     // 客戶代號
  fc120_date: string;     // 交運日期
  fc120_curr: string;     // 幣別
  fc120_net: number;      // 未稅淨額
  fc120_tax: number;      // 稅額
  fc120_tamt: number;     // 含稅金額
  fc120_item: string;     // 產品代號
  fc120_unit: string;     // 單位
  fc120_price: number;    // 單價
  fc120_qty: number;      // 數量
  fc120_amt: number;      // 外幣金額
  fc120_nt_amt: number;   // 台幣金額
  fc120_sale: string;     // 業務代號
  fc120_sale1: string;    // 業務員姓名
  fc120_col: string;      // 色號
  fc120_coln: string;     // 色號名
  sort_group: string;     // 分組欄位
  source: string;         // "FC120" | "FJ130"
}

export interface CurrencySummary {
  currency: string;
  amount: number;
  nt_amount: number;
}

export interface ReportData {
  items: ReportItem[];
  total_count: number;
  currency_summary: CurrencySummary[];
  total_nt_amount: number;
}

export interface QueryResponse {
  data: ReportData;
  message?: string;
}

// ── API Client ─────────────────────────────────────────────────────────────
export const pwc315Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.get('/api/pwc315/report', { params });
    return res.data;
  },
};
